<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>首頁區塊管理 (Homepage Sections)</h6>
            <button class="btn btn-sm btn-primary" @click="showAddModal = true">
              新增區塊
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      區塊名稱 (Key)
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      標題/內容預覽
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      排序
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="section in sections" :key="section.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">
                            {{ section.section_key }}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{
                          section.data?.title ||
                          section.data?.slides?.[0]?.title ||
                          "無標題"
                        }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <button
                        class="btn btn-link btn-sm p-0 m-0"
                        @click="moveSection(section, -1)"
                      >
                        <i class="fa fa-arrow-up"></i>
                      </button>
                      <span class="mx-2 text-xs font-weight-bold">{{
                        section.sort_order
                      }}</span>
                      <button
                        class="btn btn-link btn-sm p-0 m-0"
                        @click="moveSection(section, 1)"
                      >
                        <i class="fa fa-arrow-down"></i>
                      </button>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          section.is_active
                            ? 'bg-gradient-success'
                            : 'bg-gradient-secondary'
                        "
                      >
                        {{ section.is_active ? "啟用" : "停用" }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        @click="editSection(section)"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deleteSection(section)"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit/Add Modal would go here, for now simpler inline or separate page? -->
    <!-- Let's use a simple condition to show editor below or side-by-side if complex, but for now lets route to edit page or use modal -->
    <!-- Actually, let's keep it simple and route to a separate edit page for complex JSON editing -->
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "HomepageManager",
  data() {
    return {
      sections: [],
      showAddModal: false,
    };
  },
  created() {
    this.fetchSections();
  },
  methods: {
    async fetchSections() {
      try {
        const res = await request.get("/api/admin/homepage-sections");
        this.sections = res.data.data;
      } catch (e) {
        console.error(e);
      }
    },
    editSection(section) {
      // We will implement a specialized editor or generic JSON editor
      // For now, let's assume we navigate to a detail page
      this.$router.push(`/homepage-sections/${section.id}/edit`);
    },
    async deleteSection(section) {
      if (!confirm("確認刪除?")) return;
      try {
        await request.delete(`/api/admin/homepage-sections/${section.id}`);
        this.fetchSections();
      } catch (e) {
        alert("刪除失敗");
      }
    },
    async moveSection(section, direction) {
      // Simple swap logic or reorder API call
      // For MVP, just swap sort_order with adjacent
      // Better: implement full reorder API usage
      const index = this.sections.findIndex((s) => s.id === section.id);
      if (index + direction < 0 || index + direction >= this.sections.length)
        return;

      const other = this.sections[index + direction];
      const newOrder = [
        { id: section.id, sort_order: other.sort_order },
        { id: other.id, sort_order: section.sort_order },
      ];

      try {
        await request.post("/api/admin/homepage-sections/reorder", {
          orders: newOrder,
        });
        this.fetchSections();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
